export default class RtkRover {
  static fromApi(casterRoverItem) {
    let rover = new RtkRover()
    rover.mountpoint = casterRoverItem.id
    rover.sessions = casterRoverItem.sessions
    return rover
  }
}
